/* @jsx h */
/* @jsxFrag Fragment */
/* eslint-disable react/react-in-jsx-scope */
// eslint-disable-next-line no-unused-vars
import { h, Fragment } from 'preact';
import { useRef, useState } from 'preact/hooks';
import c from './index.module.css';
import { useMenuFocus } from './useMenuFocus';
import { useContainsFocus } from './useContainsFocus';
import { ArrowBox } from '../arrow-box';
import '@updater/ui-fa-icon';

const ENTER_KEY = 13;
const SPACE_KEY = 32;

const TOGGLE_KEY_CODES = [ENTER_KEY, SPACE_KEY];

const toModuleClasses = (classes = []) =>
  classes
    .join(' ') // Classes is an array, join all array items
    .split(' ') // Split now by spaces to get all classes
    .map(className => c[className]) // convert to module classes
    .join(' ');

export const MoverDropdown = ({ title, menuItems, routerGo, analytics }) => {
  const ref = useRef(null);
  const [open, updateOpen] = useState(false);
  const toggleOpen = () => updateOpen(!open);

  /* Listeners and handling of up/down arrows for menu nav */
  useMenuFocus({
    enabled: open,
    ref,
  });

  /* Listeners and handling of loss of focus */
  useContainsFocus({
    callback: isFocused => {
      updateOpen(isFocused);
    },
    ref,
  });

  return (
    <div className={c.moverDropdown} upd-mover-dropdown>
      <button
        className={c.toggleButton}
        onMouseDown={() => {
          toggleOpen();
          analytics?.trackToggleDropdown();
        }}
        onKeyPress={event =>
          TOGGLE_KEY_CODES.includes(event.keyCode) && toggleOpen()
        }
      >
        <div className={c.hiddenXs}>
          <span className={c.title} title>
            {title}
          </span>
          <span className={`${c.chevron} ${c.down}`} />
        </div>
        <upd-fa-icon name="bars" class={`${c.hamburger} ${c.visibleXs}`} />
      </button>

      <div
        className={`${c.popupMenuContent} ${open ? c.show : c.hide}`}
        ref={ref}
      >
        <ArrowBox className={`${c.arrowBox} ${c.top}`} top end>
          <ul role="menu" className={c.menu}>
            {menuItems.map(menuItem => (
              <li
                key={menuItem.id}
                className={toModuleClasses(menuItem.classes)}
                role="menuitem"
                aria-readonly={!menuItem.href}
              >
                {menuItem.href && (
                  <a
                    tabindex="-1"
                    href={menuItem.href}
                    onClick={e => {
                      if (routerGo) {
                        e.preventDefault();
                        routerGo(menuItem.href);
                        updateOpen(false);
                      }
                      // We are not tracking clicks in current mover-dropdown
                    }}
                  >
                    {menuItem.name}
                  </a>
                )}
                {!menuItem.href && <span>{menuItem.name}</span>}
                {menuItem.options && (
                  <ul role="menu">
                    {menuItem.options.map(option => (
                      <li
                        key={option.id}
                        className={toModuleClasses(option.classes)}
                        role="menuitem"
                        aria-readonly={!option.href}
                      >
                        {option.isCurrentMove && (
                          <upd-fa-icon name="map-marker-alt" />
                        )}
                        {option.href && (
                          <a
                            tabindex="-1"
                            href={option.href}
                            onClick={e => {
                              if (routerGo) {
                                e.preventDefault();
                                routerGo(option.href);
                                updateOpen(false);
                              }
                              analytics?.trackSwitchCurrentMove(option.params);
                            }}
                          >
                            {option.name}
                          </a>
                        )}
                        {!option.href && <span>{option.name}</span>}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </ArrowBox>
      </div>
    </div>
  );
};
